export default function audioVoice(options) {
    const targetArray = [].slice.call(document.querySelectorAll(".js-play"));
    let isPlaying = false; //再生しているかどうかのフラグ
    let voiceArray = [];

    //引数がなければデフォルトの格納先を参照
    if (options === undefined) {
        options = { path: "./assets/voice" };
    }

    targetArray.forEach((el, index) => {
        voiceArray[index] = new Audio();
        let charaNo = el.getAttribute("data-charano");
        let mpNo = el.getAttribute("data-mpNo");
        voiceArray[index].src = `${options.path}/${charaNo}/${mpNo}.mp3`;

        //クリック時
        el.addEventListener("click", function () {
            if (!isPlaying) {
                // isPlayingがfalseのとき
                voiceArray[index].play();
                el.classList.add("is-playing");
                isPlaying = true;
            } else if (isPlaying && el.classList.contains("is-playing")) {
                // isPlayingがtrue かつ is-playingクラスを持つ要素であるとき
                voiceArray[index].pause();
                el.classList.remove("is-playing");
                isPlaying = false;
            }
        });

        //再生終了時
        voiceArray[index].addEventListener("ended", function () {
            el.classList.remove("is-playing");
            isPlaying = false;
        });
    });
}
